import React from 'react'

type BadgeProps = {
  color: string
  textColor: string
  ringColor: string
  className?: string
  children: React.ReactNode
}

/**
 * Low level component for rendering a "Pill".
 *
 * @param color
 * @param textColor
 * @param ringColor
 * @param className
 * @param children
 * @constructor
 */
const Pill: React.FC<BadgeProps> = ({
  color,
  textColor,
  ringColor,
  className,
  children,
}) => {
  return (
    <span
      className={`inline-flex items-center justify-center rounded-full px-2 py-1 text-xs min-w-[44px] font-medium ${color} ${textColor} ring-1 ring-inset ${ringColor} ${
        className ?? ''
      }`}
    >
      {children}
    </span>
  )
}

export default Pill
